import { Layout } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import AppFooter from '../components/Navigation/Footer';

const { Content, Header } = Layout

function AuthLayout(): JSX.Element {
  const navigate = useNavigate()

  return (
    <Layout className="layout-container">
      <Header className="auth-layout-header">
        <div
          className="logo-container"
          onClick={() => navigate("/auth/login")}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ')
              navigate("/auth/login")
          }}
          tabIndex={0}
        >
          <div className="logo" />
          {/* <div className="logo-title">InsureFlow</div> */}
        </div>
      </Header>
      <Content className="auth-layout-content">
        <Outlet />
      </Content>
      <AppFooter />
    </Layout>
  );
}

export default AuthLayout;
